// Size equivalence mapping between bundle and upsell formats
  function getSizeEquivalent(size, productType, direction) {
    // If there's no mapping needed, just return the original size
    if (!size) return size;
    
    // For jerseys, the formats seem to match so just return the original size
    if (productType === 'jerseys') return size;
    
    // For shorts, we need to map between different formats
    if (productType === 'shorts') {
      // Mapping bundle formats to upsell formats
      const bundleToUpsell = {
        // YMQ format => Upsell format
        'GIRLS SMALL (YOUTH)': 'GIRLS SMALL',
        'GIRLS MEDIUM (YOUTH)': 'GIRLS MEDIUM',
        'GIRLS LARGE (YOUTH)': 'GIRLS LARGE',
        'GIRLS XL (YOUTH)': 'GIRLS XL',
        'BOYS SMALL (YOUTH)': 'BOYS SMALL',
        'BOYS MEDIUM (YOUTH)': 'BOYS MEDIUM',
        'BOYS LARGE (YOUTH)': 'BOYS LARGE',
        'BOYS XL (YOUTH)': 'BOYS XL',
        'WOMENS SMALL (ADULT)': 'WOMENS SMALL',
        'WOMENS MEDIUM (ADULT)': 'WOMENS MEDIUM',
        'WOMENS LARGE (ADULT)': 'WOMENS LARGE',
        'WOMENS XL (ADULT)': 'WOMENS XL',
        'MENS SMALL (ADULT)': 'MENS SMALL',
        'MENS MEDIUM (ADULT)': 'MENS MEDIUM',
        'MENS LARGE (ADULT)': 'MENS LARGE',
        'MENS XL (ADULT)': 'MENS XL',
        'MENS 2XL (ADULT)': 'MENS 2XL'
      };
      
      // Mapping upsell formats to bundle formats
      const upsellToBundle = {
        // Upsell format => YMQ format
        'GIRLS SMALL': 'GIRLS SMALL (YOUTH)',
        'GIRLS MEDIUM': 'GIRLS MEDIUM (YOUTH)',
        'GIRLS LARGE': 'GIRLS LARGE (YOUTH)',
        'GIRLS XL': 'GIRLS XL (YOUTH)',
        'BOYS SMALL': 'BOYS SMALL (YOUTH)',
        'BOYS MEDIUM': 'BOYS MEDIUM (YOUTH)',
        'BOYS LARGE': 'BOYS LARGE (YOUTH)',
        'BOYS XL': 'BOYS XL (YOUTH)',
        'WOMENS SMALL': 'WOMENS SMALL (ADULT)',
        'WOMENS MEDIUM': 'WOMENS MEDIUM (ADULT)',
        'WOMENS LARGE': 'WOMENS LARGE (ADULT)',
        'WOMENS XL': 'WOMENS XL (ADULT)',
        'MENS SMALL': 'MENS SMALL (ADULT)',
        'MENS MEDIUM': 'MENS MEDIUM (ADULT)',
        'MENS LARGE': 'MENS LARGE (ADULT)',
        'MENS XL': 'MENS XL (ADULT)',
        'MENS 2XL': 'MENS 2XL (ADULT)'
      };
      
      if (direction === 'bundle-to-upsell') {
        return bundleToUpsell[size] || size;
      } else {
        return upsellToBundle[size] || size;
      }
    }
    
    // For socks, just return the original size for now
    // Add specific mappings here if needed
    if (productType === 'socks') return size;
    
    // Default fallback
    return size;
  }/**
 * Size Synchronization for YMQ Bundles and Upsell Items
 * 
 * This script implements a flexible approach to size synchronization:
 * - When any item in a group (jerseys, shorts, socks) gets a size selected
 * - All unselected items in the same group will be updated to match
 * - Already selected items will not be changed
 * - Includes support for upsell/add-on items outside the main bundle
 * 
 * How to implement:
 * 1. Go to Shopify Admin > Online Store > Themes
 * 2. Click "Actions" on your current theme and select "Edit code"
 * 3. Under "Assets", look for a new JavaScript file (e.g., "ymq-bundle-sync.js")
 * 4. Paste this code and save
 * 5. In theme.liquid, add: <script src="{{ 'ymq-bundle-sync.js' | asset_url }}" defer></script> before the closing </body> tag
 */

(function() {
  // Store selections made by users to avoid overriding
  const userSelections = {
    jerseys: {},
    shorts: {},
    socks: {}
  };
  
  // Function to run when the page is fully loaded
  document.addEventListener('DOMContentLoaded', function() {
    // Wait for YMQ bundle to be fully loaded
    setTimeout(initSizeSync, 1500);
  });

  function initSizeSync() {
    // Initialize jerseys sync
    initGroupSync('jerseys', 'JERSEY');
    
    // Initialize shorts sync
    initGroupSync('shorts', 'SHORTS');
    
    // Initialize socks sync
    initGroupSync('socks', 'SOCKS');
    
    // Check for upsell items and connect them to the sync
    initUpsellSync();
    
    console.log('Flexible size sync initialized successfully');
  }
  
  function initGroupSync(groupType, nameFilter) {
    // Find all selectors for this group
    const selectors = document.querySelectorAll(`select[name*="${nameFilter}"]`);
    
    if (selectors.length <= 0) {
      console.log(`No ${groupType} found to sync`);
      return;
    }
    
    console.log(`Found ${selectors.length} ${groupType} selectors to sync`);
    
    // Add change event listeners to ALL selectors in this group
    selectors.forEach((selector, index) => {
      const selectorId = selector.id || `${groupType}-${index}`;
      
      // Listen for changes on any selector in this group
      selector.addEventListener('change', function() {
        const selectedSize = this.value;
        console.log(`${groupType} #${index} changed to: ${selectedSize}`);
        
        if (!selectedSize) {
          // If user clears selection, remove from user selections
          if (userSelections[groupType][selectorId]) {
            delete userSelections[groupType][selectorId];
          }
          return;
        }
        
        // Store this as a user selection
        userSelections[groupType][selectorId] = true;
        
        // Update all unselected items in this group
        updateUnselectedItems(selectors, selectedSize, groupType);
        
        // Also update upsell items for this group
        updateUpsellItems(selectedSize, groupType);
      });
    });
  }
  
  function initUpsellSync() {
    // Find all upsell items with selects
    const upsellSelectors = document.querySelectorAll('.lb-shared-variants-select');
    
    if (upsellSelectors.length <= 0) {
      console.log('No upsell selectors found');
      return;
    }
    
    console.log(`Found ${upsellSelectors.length} upsell selectors`);
    
    // Map upsell selectors to their product types (jerseys, shorts, socks)
    upsellSelectors.forEach((selector, index) => {
      // First check if we already set a product type (for reinitializations)
      const existingType = selector.getAttribute('data-product-type');
      if (existingType) {
        console.log(`Upsell #${index} already mapped to type: ${existingType}`);
        return;
      }
      
      // Get the product name from the closest product container
      const productContainer = selector.closest('.lb-spc-details-cont') || 
                               selector.closest('.lb-spc-body');
      if (!productContainer) return;
      
      const productNameElement = productContainer.querySelector('.lb-spc-details-name');
      if (!productNameElement) return;
      
      const productName = productNameElement.textContent || '';
      console.log(`Found upsell product: ${productName}`);
      
      // Determine the product type - look for keywords in the product name
      let productType = null;
      if (productName.includes('JERSEY')) {
        productType = 'jerseys';
      } else if (productName.includes('SHORTS') || productName.includes('SHORT')) {
        productType = 'shorts';
      } else if (productName.includes('SOCKS') || productName.includes('SOCK')) {
        productType = 'socks';
      }
      
      if (productType) {
        console.log(`Mapped upsell #${index} to type: ${productType}`);
        
        // Store the selector ID with its product type for later use
        selector.setAttribute('data-product-type', productType);
        
        // Add change event to also update main bundle
        selector.addEventListener('change', function() {
          const selectedSize = getSelectedValueFromUpsell(this);
          if (!selectedSize) return;
          
          console.log(`Upsell ${productType} changed to: ${selectedSize}`);
          
          // Find all main bundle selectors for this product type
          const bundleKeyword = productType.slice(0, -1).toUpperCase();
          const mainSelectors = document.querySelectorAll(`select[name*="${bundleKeyword}"]`);
          
          // Update unselected items in the main bundle
          updateUnselectedItems(mainSelectors, getSizeEquivalent(selectedSize, productType, 'upsell-to-bundle'), productType);
        });
      }
    });
  }
  
  function getSelectedValueFromUpsell(selector) {
    // Extract the actual size value from the selected option
    const selectedOption = selector.options[selector.selectedIndex];
    if (!selectedOption || selectedOption.disabled) return null;
    
    try {
      // The value is a JSON string containing product data
      const optionData = JSON.parse(selectedOption.value);
      return optionData.title; // The size is in the "title" property
    } catch (e) {
      console.error('Error parsing upsell option value:', e);
      return null;
    }
  }
  
  function updateUpsellItems(selectedSize, groupType) {
    // Find all upsell selectors for this product type
    const upsellSelectors = document.querySelectorAll(`.lb-shared-variants-select[data-product-type="${groupType}"]`);
    
    upsellSelectors.forEach((selector, index) => {
      // Convert the bundle size format to upsell size format if needed
      const upsellSize = getSizeEquivalent(selectedSize, groupType, 'bundle-to-upsell');
      
      // For upsell items, we always update them regardless of current selection
      // Find the matching option by title
      let matchingOptionIndex = -1;
      
      for (let i = 0; i < selector.options.length; i++) {
        if (selector.options[i].disabled) continue;
        
        try {
          const optionData = JSON.parse(selector.options[i].value);
          if (optionData.title === upsellSize) {
            matchingOptionIndex = i;
            break;
          }
        } catch (e) {
          console.error('Error parsing option data:', e);
        }
      }
      
      if (matchingOptionIndex > 0) {
        // Only update if the current selection is different
        if (selector.selectedIndex !== matchingOptionIndex) {
          selector.selectedIndex = matchingOptionIndex;
          
          // Trigger change event
          const event = new Event('change', { bubbles: true });
          selector.dispatchEvent(event);
          
          console.log(`Set upsell ${groupType} #${index} to size: ${upsellSize}`);
        }
      } else {
        console.log(`Size "${upsellSize}" not available in upsell ${groupType} #${index}`);
      }
    });
  }
  
  function updateUnselectedItems(selectors, selectedSize, groupType) {
    selectors.forEach((selector, index) => {
      const selectorId = selector.id || `${groupType}-${index}`;
      
      // Skip if this is a user-selected item
      if (userSelections[groupType][selectorId]) {
        console.log(`Skipping ${groupType} #${index} as it was already set by user`);
        return;
      }
      
      // Skip if already has the same value
      if (selector.value === selectedSize) {
        return;
      }
      
      // Skip if current value is not empty (another synchronization might have set it)
      if (selector.value !== "") {
        return;
      }
      
      // Check if the option exists in this dropdown
      const optionExists = Array.from(selector.options).some(option => option.value === selectedSize);
      
      if (!optionExists) {
        console.log(`Size "${selectedSize}" not available in ${groupType} #${index}`);
        return;
      }
      
      // Set the value and trigger the change event
      selector.value = selectedSize;
      
      // Trigger change event to ensure YMQ's internal state updates
      const event = new Event('change', { bubbles: true });
      selector.dispatchEvent(event);
      
      console.log(`Set ${groupType} #${index} to size: ${selectedSize}`);
    });
  }
  
  // When the page content changes (might indicate YMQ has rebuilt the bundle)
  const observer = new MutationObserver(function(mutations) {
    for (const mutation of mutations) {
      if (mutation.addedNodes.length > 0) {
        // Check if any YMQ elements or upsell elements were added
        for (const node of mutation.addedNodes) {
          if (node.nodeType === Node.ELEMENT_NODE && 
              (node.classList?.contains('ymq-options-box') || 
               node.querySelector?.('.ymq-options-box') ||
               node.classList?.contains('lb-spc-body') || 
               node.querySelector?.('.lb-spc-body'))) {
            console.log('YMQ bundle or upsell updated, reinitializing sync');
            setTimeout(initSizeSync, 500);
            return;
          }
        }
      }
    }
  });
  
  // Start observing changes to the body
  observer.observe(document.body, { childList: true, subtree: true });
  
  // Also watch for specific YMQ events if they exist
  document.addEventListener('ymq:updated', function() {
    console.log('YMQ updated event detected');
    setTimeout(initSizeSync, 500);
  });
  
  // Re-initialize when the cart is updated
  document.addEventListener('cart:updated', function() {
    console.log('Cart updated, reinitializing size sync');
    
    // Clear user selections on cart update (assuming this is a new bundle)
    userSelections.jerseys = {};
    userSelections.shorts = {};
    userSelections.socks = {};
    
    setTimeout(initSizeSync, 500);
  });
})();